// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HSlt","top":"styles_top__1Qfbl","left":"styles_left__121Tj","description":"styles_description__3lzzz"};